import React from "react";

const LABELS = {
  workflow_selected: "📋 Workflow Selected",
  document_uploaded: "📎 Document Uploaded",
  workflow_started: "▶️ Workflow Started",
  step_entered: "➡️ Step Entered",
  workflow_paused_human_gate: "🚦 Paused — Human Gate",
  esignature_applied: "✍️ E-Signature Applied",
  workflow_completed: "✅ Workflow Completed",
};

export default function DemoAuditTrail({ events, wf }) {
  const exportTrail = () => {
    const line = "────────────────────────────────────────";
    const rows = events
      .map(
        (e) =>
          `${e.timestamp}\n  ${LABELS[e.action] || e.action}: ${e.details}\n  entry_hash: ${e.entry_hash}\n  previous_entry_hash: ${e.previous_entry_hash || "GENESIS"}`
      )
      .join(`\n${line}\n`);
    const text = `${line}\nLabComplyx — Immutable Audit Trail (21 CFR §11.10(e))\nWorkflow: ${wf?.name || "—"} (${wf?.docId || "—"})\nEntries: ${events.length}\nExported: ${new Date().toISOString()}\n${line}\n${rows}\n${line}\n`;
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${wf?.docId || "demo"}-audit-trail.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div
      style={{
        border: "1px solid rgba(79,195,195,0.35)",
        borderRadius: "12px",
        padding: "1rem 1.1rem",
        background: "rgba(30,158,158,0.05)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", flexWrap: "wrap", marginBottom: "0.6rem" }}>
        <span style={{ fontWeight: 700 }}>🧾 Session Audit Trail</span>
        {events.length > 0 && (
          <span
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              color: "#4FC3C3",
              border: "1px solid rgba(79,195,195,0.5)",
              borderRadius: "999px",
              padding: "0.15rem 0.6rem",
            }}
          >
            🔗 Hash-chain intact — {events.length} {events.length === 1 ? "entry" : "entries"}
          </span>
        )}
        <span style={{ flex: 1 }} />
        {events.length > 0 && (
          <button type="button" className="lcx-doc-btn" onClick={exportTrail}>
            Export Trail
          </button>
        )}
      </div>

      {events.length === 0 ? (
        <p style={{ fontSize: "0.8rem", opacity: 0.6, margin: 0 }}>
          Every workflow event — selection, step transitions, human gates, e-signatures, and completion — is
          captured here as a SHA-256 hash-chained, tamper-evident record.
        </p>
      ) : (
        <div style={{ maxHeight: "260px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "0.45rem" }}>
          {events
            .slice()
            .reverse()
            .map((e) => (
              <div
                key={e.entry_hash}
                style={{
                  fontSize: "0.75rem",
                  padding: "0.45rem 0.6rem",
                  border: "1px solid rgba(128,128,128,0.25)",
                  borderRadius: "8px",
                }}
              >
                <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                  <span style={{ fontWeight: 700 }}>{LABELS[e.action] || e.action}</span>
                  <span style={{ opacity: 0.85 }}>{e.details}</span>
                  <span style={{ marginLeft: "auto", opacity: 0.6 }}>
                    {new Date(e.timestamp).toLocaleTimeString()}
                  </span>
                </div>
                <div style={{ opacity: 0.55, marginTop: "2px", fontFamily: "monospace", fontSize: "0.68rem" }}>
                  ⛓ {e.entry_hash.slice(0, 16)}… ← {e.previous_entry_hash ? `${e.previous_entry_hash.slice(0, 8)}…` : "GENESIS"}
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}